import {
  Model,
  Attr,
  HasOne,
  Scope,
  PersistedSpraypaintRecord,
} from 'spraypaint';
import { NullProxy, RecordProxy } from 'spraypaint/lib-esm/proxies';
import User from './User';
import DraftBusiness from './DraftBusiness';
import BaseBusiness from './BaseBusiness';

export type BusinessProxy = RecordProxy<Business> | NullProxy<Business>;

export type PersistedBusiness = PersistedSpraypaintRecord<Business>;

@Model()
export default class Business extends BaseBusiness {
  static jsonapiType = 'businesses';

  // --- Attributes
  // --------------

  // required
  // maxLength: 50
  // pattern: ^[-a-zA-Z0-9_]+$
  @Attr() slug!: string;

  @Attr() isPublic!: boolean;

  // --- Relationships
  // -----------------

  // nullable
  @HasOne() owner!: User | null;

  @HasOne() readonly draftBusiness!: DraftBusiness | null;

  // --- Paths
  // ---------

  /**
   * /backend/api/v1/businesses/
   *
   * Method: get
   * Params:
   *   - include: string
   *   - fields: object
   *   - sort: string
   *   - page[number]: integer
   *   - page[size]: integer
   *   - sort: string
   *   - filter[slug]: string
   *   - filter[name.istartswith]: string
   *   - filter[categories.in]: string
   *   - filter[search]: string
   *
   */

  /**
   * /backend/api/v1/businesses/{id}/
   *
   * Method: get
   * Params:
   *   - id: string (required)
   *   - include: string
   *   - fields: object
   *   - sort: string
   *   - sort: string
   *   - filter[slug]: string
   *   - filter[name.istartswith]: string
   *   - filter[categories.in]: string
   *   - filter[search]: string
   *
   */

  // --- Custom
  // ----------

  get hasValidQuote() {
    return !!(this.quoteImage?.id && (this.locale.quoteText || '').length > 0);
  }

  static random(): Scope<Business> {
    return Business.order('?');
  }

  async mergeDraftBusiness(): Promise<string[]> {
    const draftId = this.draftBusiness?.id;
    if (!draftId) {
      throw new Error('No draft business');
    }
    const draft = await DraftBusiness.find(draftId).then(res => res.data);
    return super.mergeAndSaveAllDataFromSource(draft);
  }

  getMergeKeysToIgnore(keys: string[]) {
    const _keys = super.getMergeKeysToIgnore(keys);
    return [
      ..._keys,
      'reviewStatus',
      'reviewMessage',
      'business',
      //
    ];
  }
}

if (process.env.NODE_ENV === 'development') {
  (() => {
    const bus = new Business();
    const descriptor = Object.getOwnPropertyDescriptor(bus, 'categories');
    if (typeof descriptor?.get !== 'function') {
      window.console.warn('Business.categories is not a getter');
    }
  })();
}
